import { useUserTable } from "../hooks/useUserTable";

const UserTable = () => {
  const {
    users,
    loading,
    error,
    editingUser,
    editForm,
    editUser,
    handleInputChange,
    updateUser,
    deleteUser,
  } = useUserTable();

  const roleColors = {
    ADMIN: "bg-primary", // Blue
    User: "bg-success", // Green
    Csd: "bg-info", // Light Blue / Cyan
    Branding: "bg-warning", // Yellow
    Manager: "bg-primary", // Gray
  };

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <h5>Loading users...</h5>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5 text-center text-danger">
        <h5>{error}</h5>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Users</h4>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table align-middle table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th>Id</th>
                  <th>Username</th>
                  <th>Email</th>
                  <th className="text-center">Role</th> {/* Centered header */}
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => {
                  return (
                    <tr key={user.id}>
                      <td>{user.id}</td>
                      <td className="fw-semibold text-dark">{user.username}</td>
                      <td
                        className="text-truncate"
                        style={{ maxWidth: "150px" }}
                      >
                        {user.email}
                      </td>
                      <td className="text-center">
                        <span
                          className={`badge ${
                            roleColors[user.role]
                          } px-3 py-1 text-uppercase text-dark`}
                        >
                          {user.role}
                        </span>
                      </td>
                      <td className="text-center">
                        <button
                          onClick={() => editUser(user)}
                          className="btn btn-sm btn-outline-warning me-1 mb-1"
                        >
                          ✏️ Edit
                        </button>
                        <button
                          onClick={() => deleteUser(user.id)}
                          className="btn btn-sm btn-outline-danger mb-1"
                        >
                          🗑️ Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
                {users.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center py-3">
                      No users found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      {editingUser && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content rounded-3 shadow-lg">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">Edit User</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => editUser(null)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Username</label>
                    <input
                      type="text"
                      className="form-control"
                      name="username"
                      value={editForm.username}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={editForm.email}
                      onChange={handleInputChange}
                    />
                  </div>
                  {/* <div className="mb-3">
                    <label className="form-label">Role</label>
                    <select
                      className="form-select"
                      name="role"
                      value={editForm.role}
                      onChange={handleInputChange}
                    >
                      <option value="ADMIN">ADMIN</option>
                      <option value="User">User</option>
                      <option value="Csd">Csd</option>
                      <option value="Branding">Branding</option>
                      <option value="Manager">Manager</option>
                    </select>
                  </div> */}
                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      value={editForm.password}
                      onChange={handleInputChange}
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => editUser(null)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={updateUser}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserTable;
